export const fontFamilyMap: Record<Fonts, string> = {
  ['Open Sans']: 'Open Sans',
  ['Goda']: 'Goda',
  ['BigShouldersText']: 'Big Shoulders Text',
  ['Brygada1918']: 'Brygada1918',
  ['Montserrat']: 'Montserrat',
};

export type Fonts = 'Open Sans' | 'Goda' | 'BigShouldersText' | 'Brygada1918' | 'Montserrat';
